import { FormControl } from "./FormControl";
import { HashMap } from "./HashMap";

interface FormGroupProps {
  [formControlName: string]: FormControl;
}

export class FormGroup {
  controls: HashMap<string, FormControl> = HashMap.empty();

  constructor(controls: FormGroupProps | HashMap<string, FormControl>) {
    if (controls instanceof HashMap) {
      this.controls = controls;
    } else {
      this.setControlsFromObject(controls);
    }
  }

  setControlValue(name: string, value: string | number | null) {
    const control = this.controls.get(name);

    if (control === undefined) {
      throw new Error(`FormControl "${name}" does not exists`);
    }

    if (control.value === value) {
      return this;
    }

    return new FormGroup(this.controls.set(name, new FormControl(value, control.validators)));
  }

  isValid() {
    for (const [, control] of this.controls.entries()) {
      if (!control.isValid()) {
        return false;
      }
    }

    return true;
  }

  isDirty() {
    for (const [, control] of this.controls.entries()) {
      if (control.isDirty()) {
        return true;
      }
    }

    return false;
  }

  setControlsFromObject(controls: FormGroupProps) {
    for (const key in controls) {
      this.controls = this.controls.set(key, controls[key]);
    }
  }
}
